import request from '@/router/axios'
import { commonConst } from '@/const/code.js'
import user from "../../store/modules/user";
import { encrypt, decrypt } from '@/util/util';
const urlPrefix = '/hrcloud'

export const loginByUsername = (data) => {
  const grant_type = 'password';
  const scope = 'server';
  const tenantId = commonConst.TENANT_ID;
  return request({
    url: urlPrefix+'/webapi/userLogon.action',
    headers: {
      Authorization: 'Basic d2FnZTp3YWdl',
    },
    method: 'post',
    params: {req: encrypt(JSON.stringify(data))},
  });
};
export const ygjLogon = (data) => {
  return request({
    url: urlPrefix+'/webapi/ygjLogon.action',
    headers: {
      Authorization: 'Basic d2FnZTp3YWdl',
    },
    method: 'post',
    params: data,
  });
};
export const loginByPhone = (mobile, code) => {
  const grant_type = 'mobile';
  const scope = 'server';
  const type = '2';
  const tenantId = commonConst.TENANT_ID;
  return request({
    url: '/auth/mobile/token',
    headers: {
      Authorization: 'Basic d2FnZTp3YWdl',
    },
    method: 'post',
    params: { mobile, code, grant_type, scope ,type,tenantId},
  });
}
export const requestRefreshToken = (refresh_token) => {
  const grant_type = 'refresh_token';
  const scope = 'server';
  const type = '1';
  const tenantId = commonConst.TENANT_ID;
  return request({
    url: '/auth/oauth/token',
    headers: {
      Authorization: 'Basic d2FnZTp3YWdl',
    },
    method: 'post',
    params: { grant_type, scope, refresh_token,type,tenantId},
  });
};

export const getUserInfo = () => request({
  url: '/user/user/info',
  method: 'get',
});

export const logout = (accessToken, refreshToken) => request({
  // url: '/auth/authentication/removeToken',
  url: urlPrefix+'/webapi/userLogout.action',
  method: 'post',
  params: { accessToken, refreshToken },
});
export const getAllOrg = (userId, orgId) => request({
  url: `/user/user/${userId}/org/${orgId}`,
  method: 'get',
});

export const cacheUser = (userId, orgId, createOrgId) => request({
  url: '/user/user/cache',
  method: 'post',
  data: { userId, orgId, createOrgId },
});
export const getCusList = (params) => request({
  url: urlPrefix+'/webapi/queryCusList.action',
  method: 'post',
  params:{
    loginName:params
  }
});
export const switchCus=(data) =>  request({
  url: urlPrefix+'/webapi/switchCus.action',
  method: 'post',
  data: data,
});
export const switchLanguage=(data) =>  request({
  url: urlPrefix+'/webapi/switchLanguage.action',
  method: 'post',
  data: data,
});

// 微信二维码
export const produceQrCode = () => request({
  url: `/wc/produceQrCode`,
  method: 'get',
});

// 微信获取信息
export const wcLogin = (params) => request({
  url: `/wc/wcLogin`,
  method: 'get',
  params
});
// 云管家拼接菜单参数 接收 targetUrl
export const ygjMenuParamTo = (data) => {
  return request({
    url: urlPrefix + '/webapi/ygjMenuParamTo.action',
    method: 'post',
    params: data,
  });
};


// 官网首页
export const gwSaveReportInfo = (data) => request({
  url: `/hrcloud/saveReportInfo.action`,
  method: 'post',
  data
});
